export const downloadModalContent = (props) => {
  const {
    reportTitle,
    reportIntro,
    fullReportThumbnail,
    sustainabilityBrochureTitle,
    sustainabilityIntro,
    sustainabilityThumbnail,
  } = props || {}
  return {
    title: "Download our reports",
    downloads: [
      {
        id: "download01",
        title: reportTitle,
        intro: reportIntro,
        thumbnailUrl: fullReportThumbnail.file.url,
        thumbnailAlt: fullReportThumbnail.description,
        brochureType: "progressReports",
      },
      {
        id: "download02",
        title: sustainabilityBrochureTitle,
        intro: sustainabilityIntro,
        thumbnailUrl: sustainabilityThumbnail.file.url,
        thumbnailAlt: sustainabilityThumbnail.description,
        brochureType: "sustainabilityRoadmap",
      },
    ],
  }
}
